import * as React from "react";
import {Link} from "react-router-dom";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {resourcesHelper} from "@ferry/portal-core";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IProps {
    id?: string;
    src: string;
    alt: string;
    to: string;
    openInNewWindow?: boolean;
    notification?: boolean;
    status?: string;
    className?: string;
    routeState?: any;
    hasInfoButton?: boolean;
    infoModalBulletPoints?: string[];
    infoModalBulletPointTitle?: string;
    infoModalTitle?: string;
    infoModalAdditionalDescription?: React.ReactNode;
    infoModalButton?: string;
    infoModalButtonHidden?: boolean;
    linkDisabled?: boolean;
    backButtonName?: string;
    backButtonHidden?: boolean;
}

interface IState {
    isOpen: boolean;
}

export class ImgTileLinkPlain extends React.Component<IWithRouterProps & React.PropsWithChildren<IProps>, IState> {

    public constructor(props: IWithRouterProps & React.PropsWithChildren<IProps>) {
        super(props);
        this.state = {
            isOpen: false,
        };

        this.toggleInfoModal = this.toggleInfoModal.bind(this);
        this.proceedToLink = this.proceedToLink.bind(this);
    }

    public render() {
        const {
            id, to, src, alt, children, notification,
            className, routeState, status,
            infoModalTitle, hasInfoButton,
            infoModalButton, infoModalBulletPointTitle, infoModalAdditionalDescription, linkDisabled, infoModalButtonHidden, backButtonHidden,
            backButtonName
        } = this.props;
        const targetProp: string = this.props.openInNewWindow ? '_blank' : '';

        return (
            <>
                <Link id={id || ""}
                      to={{
                          pathname: to
                      }}
                      state={routeState}
                      target={targetProp}
                      onClick={e => linkDisabled ? this.showInfoDialog(e) : this.emptyMethod()}
                      className={`img-tile-link ${className || ""} ${!!status && "with-status"}`}>
                        {notification && <div className="notification"/>}
                        {!!status && <div className={`status ${status}`}>{status}</div>}
                        <img src={src} alt={alt}/>
                        <div className="link-name">
                            {children}
                            {hasInfoButton &&
                                <div className={`info-button cursor-pointer ${this.props.className}`}
                                     onClick={e => this.showInfoDialog(e)}/>}
                        </div>
                </Link>
                <Modal className="my-2 tile-link-info-modal" isOpen={this.state.isOpen} toggle={this.toggleInfoModal}>
                    <ModalHeader toggle={this.toggleInfoModal}>
                        <div className="info-popup-title">
                            <img src={`/${resourcesHelper.THEME_PATH}/img/info-popup.svg`} alt="Attention"/>
                            <div className="text-blue-2 font-weight-bold">{infoModalTitle}</div>
                        </div>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        <h3 className="fs-16 mb-3 font-weight-600">{infoModalBulletPointTitle ?? "What can I do here?"}</h3>
                        {infoModalAdditionalDescription}
                        {this.renderBulletPoints()}
                    </ModalBody>
                    <ModalFooter>
                        {!backButtonHidden &&
                        <Button className="my-2 w-100 float-right" color="btn btn-white"
                                onClick={this.toggleInfoModal}>
                            {backButtonName ?? "Back"}
                        </Button>
                        }
                        {!infoModalButtonHidden &&
                        <Button className="my-2 px-4 w-100 float-right"
                                color="btn btn-primary btn-next-no-arrow" onClick={this.proceedToLink}>
                            {infoModalButton ? infoModalButton : infoModalTitle}
                        </Button>
                        }
                    </ModalFooter>
                </Modal>
            </>
        );
    }

    private renderBulletPoints() {
        const bulletPoints = this.props.infoModalBulletPoints || [];
        return (
            <ul className="info-modal-bullet-points">
                {bulletPoints.map((point, index) => (
                    <li key={index} className="mb-2">
                        <img className="info-modal-tick-icon" src="/img/tick.svg" alt="Green Tick"/>
                        {point}
                    </li>
                ))}
            </ul>
        );
    }

    // tslint:disable-next-line:no-empty
    private emptyMethod() {
        // required since there is no execute default method
    } // NOSONAR

    private showInfoDialog(event: any): void {
        event.stopPropagation();
        event.preventDefault();
        this.toggleInfoModal();
    };

    private proceedToLink(): void {
        const {to, routeState} = this.props;
        if (/^https?:\/\//.test(to)) {
            // It's an external URL, use window.location.href to navigate
            window.open(to, '_blank');
        } else {
            this.props.navigate(to, routeState);
        }

        this.toggleInfoModal();
    };

    private toggleInfoModal(): void {
        this.setState((state: IState) => ({
            isOpen: !state.isOpen
        }));
    }
}

export const ImgTileLink = withRouter<React.PropsWithChildren<IProps>>(ImgTileLinkPlain)
